import { useMemo, useState } from 'react';

import { ProgressMultiItem } from 'twyne-new.ui'

import Form from './Form';

export default function Item({ device, data, options, index, total, onChange, onRemove, disabled }) {
  const [toggle, setToggle] = useState(false)

  const name = useMemo(() => options?.find(form => form.value === data.id)?.label, [options, data])
  const { weight } = data
  const target = `${device}-${index}`

  return <>
    <ProgressMultiItem
      value={(weight / total) * 100}
      label={name}
      aria-disabled={disabled}
      onClick={() => setToggle(!toggle)}
      className={!disabled && 'cursor-pointer'}
    />
    <Form
      target={target}
      index={index}
      data={data}
      options={options}
      name={name}
      onChange={onChange}
      onRemove={onRemove}
      toggle={toggle}
      setToggle={setToggle}
    />
  </>
}